import { render, staticRenderFns } from "./company-inactive.component.html?vue&type=template&id=c4084fa8&scoped=true&external"
import script from "./company-inactive.component.ts?vue&type=script&lang=ts&external"
export * from "./company-inactive.component.ts?vue&type=script&lang=ts&external"
import style0 from "./company-inactive.component.scss?vue&type=style&index=0&id=c4084fa8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4084fa8",
  null
  
)

export default component.exports